import appConfig from "constants/appConfig";

import { PRODUCT_TYPE } from "../../constants/productType";

import type { ParsedSettlement } from "../../types/parsedSettlement";

// イベント画像のサムネイルURLを構築する
export const getEventImageThumbnail = (
  bannerImage: string,
  defaultImage: string
): string | null => {
  const PUBLIC_DB_URL = appConfig.publicStorageDomain ?? "";
  if (bannerImage) {
    return `${PUBLIC_DB_URL}/${bannerImage}_1280x720`;
  }
  return defaultImage === "" ? null : defaultImage;
};

type GetImagePath = (settlement: ParsedSettlement) => string;

// 最初の商品の画像を購入履歴一覧のサムネイルとして使用する
export const getImagePath: GetImagePath = (settlement) => {
  // lineItemsがある場合はグッズ扱い（最初の商品のサムネイルを使用）
  if (Array.isArray(settlement.lineItems) && settlement.lineItems.length > 0) {
    const [firstLineItem] = settlement.lineItems;
    return firstLineItem?.thumbnail ?? "";
  }

  if (!Array.isArray(settlement.products) || settlement.products.length === 0) {
    return "";
  }

  const [firstProduct] = settlement.products;
  if (!firstProduct) {
    return "";
  }

  // チケットの場合はイベント画像を使用
  if (firstProduct.productType === PRODUCT_TYPE.TICKET && firstProduct.eid) {
    const eventImage = settlement.eventImages[firstProduct.eid];
    if (eventImage) {
      return (
        getEventImageThumbnail(
          eventImage.bannerImage,
          eventImage.defaultImage
        ) ?? ""
      );
    }
  }

  // グッズの場合は商品のサムネイルを使用
  return firstProduct.thumbnail ?? "";
};
